export default "__VITE_ASSET__Dfjpok1i__"